
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--input condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElInput
        v-on="$listeners"
        v-bind="contentProps"
        :disabled="insetDisabled"
        :value="checked"
        @input="debounceChange"
        @keydown.native.enter="enterHandle"
        class="condition-item__content"
    >
        <template v-if="slotPrefix || $slots.prefix" #prefix>
            <slot v-if="$slots.prefix" name="prefix"></slot>
            <component v-else :is="getNode(slotPrefix, { backfill, query, search, insideSearch })"></component>
        </template>
        <template v-if="slotSuffix || $slots.suffix" #suffix>
            <slot v-if="$slots.suffix" name="suffix"></slot>
            <component v-else :is="getNode(slotSuffix, { backfill, query, search, insideSearch })"></component>
        </template>
        <template v-if="slotPrepend || $slots.prepend" #prepend>
            <slot v-if="$slots.prepend" name="prepend"></slot>
            <component v-else :is="getNode(slotPrepend, { backfill, query, search, insideSearch })"></component>
        </template>
        <template v-if="slotAppend || $slots.append" #append>
            <slot v-if="$slots.append" name="append"></slot>
            <component v-else :is="getNode(slotAppend, { backfill, query, search, insideSearch })"></component>
        </template>
    </ElInput>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
